import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  const ricarica = () => api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));

  useEffect(() => {
    ricarica();
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("token", data.token);
    setUser(data.user);
  };

  const registra = async (payload) => {
    const { data } = await api.post("/auth/registra", payload);
    localStorage.setItem("token", data.token);
    setUser(data.user);
  };

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    localStorage.removeItem("token");
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, login, logout, registra, ricarica }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
